import type { Reducer } from "@reduxjs/toolkit";
import type { StorylineActionTypes } from "../../src/store/storyline/types";
import { MapWithPathSupport } from "../../src/shared/utilities";

type MockState = {
    parameterValues: MapWithPathSupport<any>;
    canvasState: Record<string, any>;
    currentParagraph: {
        data: Record<string, any>;
    };
    storyline: Record<string, any>;
}

const initialState: MockState = {
    parameterValues: new MapWithPathSupport<any>(),
    canvasState: {},
    currentParagraph: {
        data: {},
    },
    storyline: {
        templates: {},
    },
};

export const storylineReducer: Reducer<MockState, any, MockState> = (state = initialState, action: StorylineActionTypes) => {
    switch (action.type) {
        case "PARAMETER_VALUE_UPDATED":
            const parameterValues = new MapWithPathSupport(state.parameterValues.entries());
            parameterValues.set(action.parameterName, action.newValue);
            return {
                ...state,
                parameterValues
            };

        case "UPDATE_CANVAS_STATE":
            return {
                ...state,
                canvasState: action.newState
            };

        case "UPDATE_CURRENT_FRAME_DATA":
            return {
                ...state,
                currentParagraph: {
                    ...state.currentParagraph,
                    data: action.newData
                }
            };

        case "UPDATE_SLIDE_TEMPLATES":
            return {
                ...state,
                storyline: {
                    ...state.storyline,
                    templates: action.newTemplates
                },
            };

        default:
            return state;
    }
};